import { createSlice } from '@reduxjs/toolkit';

import { createRestSlice } from '../../utils/RestSlice';
import BonusRepository from '../../repositories/Admin/BonusRepository';

const bonusRestSlice = createRestSlice({
  resource: 'bonus',
  repository: BonusRepository,
  slices: ['createBonus'],
});

const initialState = {
  ...bonusRestSlice.initialState,
};

const bonusSlice = createSlice({
  name: 'bonus',
  initialState,
  reducers: {
    ...bonusRestSlice.reducers,
  },
});
export default bonusSlice.reducer;

export const bonusRestHooks = bonusRestSlice.hooks(bonusSlice, [
  'admin',
  'BonusSlice',
]);
